import { PipeTransform, Pipe } from '@angular/core';
import { OrderPeriodType } from '../types/deal.types';

@Pipe({
  name: 'orderPeriodType',
  standalone: false,
})
export class OrderPeriodTypePipe implements PipeTransform {
  public transform(value: OrderPeriodType): string | null {
    switch (value) {
      case OrderPeriodType.retail:
        return '(R)';
      case OrderPeriodType.all:
      case OrderPeriodType.institutional:
      default:
        return null;
    }
  }
}
